import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import ToolTipComponent from "./ToolTipComponent";
import { ReactComponent as CopyIcon } from "../../assets/images/CopyIconCustomerTable.svg";
import { ReactComponent as CopyIconWhite } from "../../assets/images/icons/copyiconWhite.svg";
import { FaCheck } from "react-icons/fa"; // Import check icon
import { color } from "framer-motion";

const CopyIconComponent = ({ copyValue }) => {
  const [isCopied, setIsCopied] = useState(false);
  const dispatch = useDispatch();

  const handleCopy = (copyText) => {
    if (!copyText) return;

    navigator.clipboard
      .writeText(copyText)
      .then(() => {
        setIsCopied(true);
        // setIsTooltipGreen(true);

        // dispatch(
        //   pushAlert({
        //     visible: true,
        //     message: "Text Copied to Clipboard",
        //     type: "success",
        //   })
        // );
      })
      .catch((err) => console.error("Failed to copy:", err));
  };

  useEffect(() => {
    let timer;
    if (isCopied) {
      timer = setTimeout(() => {
        setIsCopied(false);
        // setIsTooltipGreen(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isCopied]);

  return (
    <ToolTipComponent
      style={{ padding: "0px" }}
      arrowStyle={{ color: isCopied ? "#37C015" : "#FFFFFF" }}
      textOnly
      text={
        <p
          className={`px-2 py-1 rounded transition-all duration-300 flex gap-1 ${
            isCopied ? "bg-[#37C015] text-white" : "bg-white text-black"
          }`}
        >
          {isCopied ? <CopyIconWhite /> : <CopyIcon className="cursor-pointer" />}
          {isCopied ? "Copied " : "Copy"} to Clipboard
        </p>
      }
    >
      <div onClick={() => handleCopy(copyValue)} className="cursor-pointer">
        {isCopied ? <FaCheck className="text-[#37C015]" /> : <CopyIcon className="cursor-pointer" />}
      </div>
    </ToolTipComponent>
  );
};

export default CopyIconComponent;
